module.exports = __webpack_public_path__ + "img/password.3a1cbd40.svg";